module.exports = __webpack_public_path__ + "static/messages_bsaket-923d787e06ef7cfdbdeb529c309f33cc.mp4";